

const tabButtons = document.querySelectorAll('.home-products-tab-wrapper .tab_button');
const tabContents = document.querySelectorAll('.home-products-tab-wrapper .tab_content');


tabButtons[0].classList.add('active');
tabContents[0].classList.add('active');
initSplides(tabContents[0]); 

let currentTab = 0;

// Add click event listener to all tab buttons
tabButtons.forEach((btn, index) => {
  btn.addEventListener('click', () => {
    tabButtons.forEach(b => b.classList.remove('active'));
    tabContents.forEach(c => c.classList.remove('active'));

    btn.classList.add('active');
    tabContents[index].classList.add('active');

    initSplides(tabContents[index]); 
    currentTab = index; // update current tab index
  });
});

// Automatically switch tabs every 15 seconds
setInterval(() => {
  currentTab = (currentTab + 1) % tabButtons.length; // loop back to first tab
  tabButtons[currentTab].click(); // trigger click
}, 15000);

function initSplides(container) {
  container.querySelectorAll('.tab_col_splide').forEach((sliderElement) => {
    // Prevent double initialization
    if (!sliderElement.classList.contains('splide-initialized')) {
      const splide = new Splide(sliderElement, {
        type: 'slide',
        padding: '5%',
        perPage: 3,
        start: 2,
        pagination: false,
        focus: 'center',
        trimSpace: true,
        gap: '24px',
        wheel: true,
        releaseWheel: true,
        breakpoints: {
          640: {
            perPage: 1,
            padding: '20%',
          },
        },
      });

      const bar = sliderElement.querySelector('.my-slider-progress-bar');

      if (bar) {
        splide.on('mounted move', function () {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min((splide.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        });
      }

      splide.mount();
      sliderElement.classList.add('splide-initialized');
    }
  });
}


